import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import { Box, Card, Typography } from '@mui/material';
import { IconHeartbeat } from '@tabler/icons-react';
import MainCard from '../../../component/cards/MainCard';
import SkeletonEarningCard from '../../../component/cards/Skeleton/EarningCard';

const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.dark,
    color: '#fff'
}));

const StyledIconHeartbeat = styled(IconHeartbeat)(() => ({
    width: '100px',
    height: '100px'
}));

function PlanosCard({ isLoading, planName, planDesc, pacientType, onClick }) {
    return (
        <>
            {isLoading ? (
                <SkeletonEarningCard />
            ) : (
                <div
                    role="button"
                    tabIndex={0}
                    onClick={onClick}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') onClick();
                    }}
                    style={{ cursor: 'pointer' }}
                >
                    <CardWrapper
                        content={false}
                        sx={{
                            '&:hover': {
                                boxShadow: 6,
                                transform: 'scale(1.02)',
                                transition: '0.2s ease-in-out'
                            }
                        }}
                    >
                        <Card
                            elevation={0}
                            sx={{
                                display: 'flex',
                                backgroundColor: 'transparent',
                                boxShadow: 'none'
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '20px'
                                }}
                                className="CardioId-CardContent-Planos-counter"
                            >
                                <StyledIconHeartbeat />
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    flex: 'auto',
                                    flexDirection: 'column',
                                    alignContent: 'flex-start',
                                    justifyContent: 'space-around',
                                    padding: '10px'
                                }}
                            >
                                <Typography component="div" variant="h2" color="#fff">
                                    {planName}
                                </Typography>
                                <Typography component="div" variant="h4" color="#d6d5d5">
                                    {planDesc}
                                </Typography>
                                <Typography component="div" variant="h5" color="#d6d5d5">
                                    {pacientType}
                                </Typography>
                            </Box>
                        </Card>
                    </CardWrapper>
                </div>
            )}
        </>
    );
}

PlanosCard.propTypes = {
    isLoading: PropTypes.bool,
    pacientType: PropTypes.string.isRequired,
    planName: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export default PlanosCard;
